import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import errors from '@/store/modules/errors';
import ui from '@/store/modules/ui';
import design from '@/store/modules/design';
import elements from '@/store/modules/elements';
import finalizeOrder from '@/store/modules/finalizeOrder';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    errors,
    ui,
    design,
    elements,
    finalizeOrder,
  },
});
